/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ivory_Free_Dove_DozeInputs */

const en_ivory_free_dove_doze = /** @type {(inputs: Ivory_Free_Dove_DozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will overwrite the current result configuration. Continue?`)
};

const de_ivory_free_dove_doze = /** @type {(inputs: Ivory_Free_Dove_DozeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dies überschreibt die aktuelle Ergebniskonfiguration. Fortfahren?`)
};

/**
* | output |
* | --- |
* | "This will overwrite the current result configuration. Continue?" |
*
* @param {Ivory_Free_Dove_DozeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ivory_free_dove_doze = /** @type {((inputs?: Ivory_Free_Dove_DozeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ivory_Free_Dove_DozeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ivory_free_dove_doze(inputs)
	return de_ivory_free_dove_doze(inputs)
});